import * as React from "react";
import Spinner from "../../common/components/spinner/spinner";
import { UserModel } from "../../models/user/userModel";
import AuthService from "../../services/authService";
import Snackbar from "../../common/components/snackbar/snackbar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import * as actionTypes from '../../store/actionTypes';
import Translate from '../../common/functions/translate';

interface IProps {
    history: any;
    onUserLogin: any;
    dialogOpen: boolean;
    closeDialog: any;
}

interface IState {
    isLoading: boolean;
    user: UserModel;
    isLogged: boolean;
}

class LoginComponent extends React.Component<IProps, IState> {
    authService = new AuthService();
    snackbar: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            user: new UserModel(),
            isLogged: false
        };
    }

    componentDidMount() { }

    handleChange = (key, value) => {
        const user: UserModel = { ...this.state.user };
        user[key] = value;
        this.setState({ user: { ...user } });
    };

    handleKeyPress = e => {
        if (e.key === "Enter") {
            this.handleLoginButton(e);
        }
    };

    isValidAddEditForm() {
        let message = "";

        if (!this.state.user.email || this.state.user.email.trim() === "") {
            message += Translate('Please enter email') + " ";
        }

        if (!this.state.user.password || this.state.user.password.trim() === "") {
            message += Translate('Please enter Password') + " ";
        }

        if (message !== "") {
            this.snackbar.show({ severity: "error", summary: message });
        }

        return message === "";
    }

    handleLoginButton = event => {
        event.preventDefault();

        if (!this.isValidAddEditForm()) return;

        this.setState({
            isLoading: true
        });

        const user = this.state.user;

        this.authService
            .login(user.email, user.password)
            .then((data: any) => {
                if (data) {
                    this.setState(
                        {
                            isLoading: false,
                            isLogged: data,
                            user: new UserModel()
                        }, () => this.redirectAfterLogin()
                    );
                }
            })
            .catch(error => {
                this.snackbar.show({ severity: "error", summary: Translate(error.message) });
                this.setState({
                    isLoading: false
                });
            });
    };

    redirectAfterLogin() {
        this.props.onUserLogin();
        this.props.history.push('/');

        // if (this.authService.checkIsAdmin()) {
        //     this.props.history.push(`/users`);
        // } else if (this.authService.checkIsProductManager()) {
        //     this.props.history.push(`/products`);
        // } else if (this.authService.checkIsRegionalManager() || this.authService.checkIsTrader()) {
        //     this.props.history.push(`/offers`);
        // }
    }

    public render() {
        const { isLoading, user } = this.state;

        return (
            <>
                {isLoading ? <Spinner /> : null}
                <Snackbar ref={(el) => this.snackbar = el} />
                <div className="login-panel">
                    <h2>{Translate('Login')}</h2>

                    <div>
                        <div className="p-g p-fluid">
                            <div className="p-g-12" style={{ marginBottom: "20px" }}>
                                <TextField
                                    name="email"
                                    label={Translate('Email')}
                                    type="email"
                                    value={user && user.email ? user.email : ""}
                                    onChange={(e) => this.handleChange('email', e.target['value'])}
                                />
                            </div>
                            <div className="p-g-12" style={{ marginBottom: "20px" }}>
                                <TextField
                                    type="password"
                                    name="password"
                                    label={Translate('Password')}
                                    onKeyPress={this.handleKeyPress}
                                    onChange={(e) => this.handleChange('password', e.target['value'])}
                                    value={user && user.password ? user.password : ""}
                                />
                            </div>

                            <div style={{ width: 200, marginTop: 30 }}>
                                <Button variant="contained" size="medium" color='primary' onClick={this.handleLoginButton}
                                    style={{ width: '100%', marginBottom: '15px' }}>
                                    {Translate('Login')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUserLogin: () => dispatch({ type: actionTypes.USER_LOGIN })
    }
}

export default connect(null, mapDispatchToProps)(LoginComponent);
